<template>
  <section class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <table class="table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <CotizrColumnHeader
                  field="entidad"
                  v-bind:showIcon="showEntidadHeaderIcon"
                  v-bind:onSort="sortBy"
                />
                <CotizrColumnHeader
                  field="compra"
                  v-bind:showIcon="showCompraHeaderIcon"
                  v-bind:onSort="sortBy"
                />
                <CotizrColumnHeader
                  field="venta"
                  v-bind:showIcon="showVentaHeaderIcon"
                  v-bind:onSort="sortBy"
                />
                <CotizrColumnHeader
                  field="actualizado"
                  v-bind:showIcon="showActualizadoHeaderIcon"
                  v-bind:onSort="sortBy"
                />
              </tr>
            </thead>
            <tbody v-if="values">
              <CotizrRow
                v-for="(value, index) in values"
                v-bind:key="index"
                v-bind:value="value"
              />
            </tbody>
            <tbody v-if="loading">
              <tr>
                <td colspan="4">
                  <font-awesome-icon
                    icon="spinner"
                    spin
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-if="error">
              <tr>
                <td colspan="4">
                  <span class="has-text-danger">{{ error }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CotizrColumnHeader from './CotizrColumnHeader'
import CotizrRow from './CotizrRow'
import currencyFormat from '../services/currencyFormat'
import fetchCotizaciones from '../services/cotizaciones'

export default {
  name: 'CotizrTable',
  components: {
    CotizrColumnHeader,
    CotizrRow
  },
  data () {
    return {
      loading: false,
      values: undefined,
      sortField: undefined,
      error: undefined
    }
  },
  created () {
    this.fetchValues()
  },
  methods: {
    fetchValues: async function () {
      this.loading = true
      try {
        this.values = await fetchCotizaciones()
        this.setTitle()
      } catch (e) {
        this.error = e.toString()
      }
      this.loading = false
    },
    setTitle () {
      if (this.values.length > 0) {
        this.sortBy('venta', false)
        const value = this.values[0]
        const venta = currencyFormat.format(value.venta)
        document.title = `Venta a ${venta} en el ${value.entidad}`
      } else {
        this.error = 'Sin Datos'
      }
    },
    sortBy (field, reverse) {
      const modifier = reverse ? -1 : 1
      this.values.sort(
        (a, b) => modifier * ((a[field] > b[field]) - (b[field] > a[field]))
      )
      this.sortField = field
    }
  },
  computed: {
    showEntidadHeaderIcon () {
      return this.sortField === 'entidad'
    },
    showCompraHeaderIcon () {
      return this.sortField === 'compra'
    },
    showVentaHeaderIcon () {
      return this.sortField === 'venta'
    },
    showActualizadoHeaderIcon () {
      return this.sortField === 'actualizado'
    }
  }
}
</script>

<style lang="scss" scoped>
td[colspan="4"] {
  text-align: center;
}
</style>
